import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import * as Chart from 'chart.js';
import * as moment from 'moment';

import { AuthService } from '../services/auth.service';
import { ManutencaoService } from '../services/manutencao.service';
import { ManutencaoPecaService } from '../services/manutencao-peca.service';
import { VeiculoService } from '../services/veiculo.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

@Component({
	selector: 'app-dashboard-frotas',
	templateUrl: './dashboard-frotas.component.html',
	styleUrls: ['./dashboard-frotas.component.css'],
	animations: [loadingFade, modal, alert]
})
export class DashboardFrotasComponent implements OnInit {

	//Id do menu da tb_menu
	public menu_id = 103; //checklist	

	public loading = false;

	public manutencoes;
	public veiculos = [];
	public manutencoes_array = [];
	public slides = [];
	public manutencoesAtrasadas = 0;
	public manutencoesProximas = 0;
	public manutencoesEmDia = 0;
	public usuario_perfil;

	public veiculo = '';
	public despesa = '';
	public dataVencimento = '';
	public dataAtual = moment(new Date()).format("YYYY-MM-DD");

	// paginacao
	public page = 1;
	public limit = 7;
	public count = 0;

	//acesso
	public visualizar = true;
	public editar = false;	

	// slick
	slideConfig = {
		"slidesToShow": 1,
		"slidesToScroll": 1,
		"infinite": true,
		"dots": true,
		"arrows": false,
		"autoplay": true,
		"responsive": [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				}
			}
		]
	};
	private slideLimit = 5;

	constructor(private authSvc: AuthService,
		private manutencaoSvc: ManutencaoService,
		private veiculoSvc: VeiculoService,
		private manutencaoPecaSvc: ManutencaoPecaService,
		private perfilUsuarioSvc: PerfilUsuarioService
	) { }

	ngOnInit() {

		this.pegaManutencoes();
		this.pegaVeiculos();

		this.usuario_perfil = this.authSvc.getPerfil();


		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {


			if(typeof data[0] === "undefined"){
				this.visualizar = false;
			}else{

				if(data[0].visualizar){
					this.visualizar = true;
				}	
			}


		}).catch((err) => {
		console.log(err);
		});

	}

	manutencoesChart(mAtrasada, mProxima, mDia) {
		this.manutencoes = new Chart('canvas', {
			type: 'doughnut',
			data: {
				labels: ["Atrasada", "Próxima", "Em Dia"],
				datasets: [
					{
						data: [mAtrasada, mProxima, mDia],
						backgroundColor: ["#ff0000", "#ffe500", '#41ce00']
					}
				]
			},
			options: {
				legend: {
					display: true,
					position: 'bottom',
					labels: {
						boxWidth: 20
					}
				},
				rotation: 1 * Math.PI,
				circumference: 1 * Math.PI

			}
		});
	}

	pegaManutencoes() {
		this.loading = true;

		this.manutencaoSvc.getManutencoesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			for (let manutencao of data) {
				for (let peca of manutencao.pecas_vencimento) {
					if (peca.manutencao_peca_validade < this.dataAtual || peca.manutencao_peca_validade_km < manutencao.veiculo.quilometragem) {
						this.manutencoesAtrasadas++;
					}
					else if (peca.manutencao_peca_validade <= this.dataAtual || (peca.manutencao_peca_validade_km - 1000) < manutencao.veiculo.quilometragem) {
						this.manutencoesProximas++;
					}
					else {
						this.manutencoesEmDia++;
					}
				}
			}
			this.manutencoesChart(this.manutencoesAtrasadas, this.manutencoesProximas, this.manutencoesEmDia);

			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
		this.manutencaoPecaSvc.getManutencaoPeca(this.authSvc.getUsuarioId()).then((data: any) => {
			this.slides = data;
			for (let i = 0; i < this.slides.length; i++) {
				if (this.slides[i].manutencao_peca_validade < this.dataAtual || this.slides[i].manutencao_peca_validade_km < this.slides[i].manutencao.veiculo.quilometragem) {
					this.slides[i]["classe"] = 'late';
				}
				else if (this.slides[i].manutencao_peca_validade <= this.dataAtual || (this.slides[i].manutencao_peca_validade_km - 1000) < this.slides[i].manutencao.veiculo.quilometragem) {
					this.slides[i]["classe"] = 'near';
				}
				else {
					this.slides[i]["classe"] = 'onTime';
				}
			}
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaVeiculos() {
		let atrasadas = 0;
		let proximas = 0;
		let emDia = 0;
		this.veiculoSvc.getVeiculosManutencao(this.authSvc.getUsuarioId()).then((data: any) => {
			for (let veiculo of data) {
				for (let manutencao of veiculo.manutencao_pecas) {
					for (let peca of manutencao.pecas_vencimento) {
						if (peca.manutencao_peca_validade < this.dataAtual || peca.manutencao_peca_validade_km < veiculo.quilometragem) {
							atrasadas++;
						}
						else if (peca.manutencao_peca_validade <= this.dataAtual || (peca.manutencao_peca_validade_km - 1000) < veiculo.quilometragem) {
							proximas++;
						}
						else {
							emDia++;
						}
					}
				}
				this.veiculos.push({ 'veiculo': veiculo.veiculo_placa, 'atrasadas': atrasadas, 'proximas': proximas, 'emDia': emDia });
				atrasadas = 0;
				proximas = 0;
				emDia = 0;
			}
			this.count = this.veiculos.length;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}
}
